"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Navbar_1 = __importDefault(require("../../components/Navbar"));
var material_1 = require("@mui/material");
function CheckoutSuccess() {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Navbar_1.default, { iconNumber: 1 }),
        react_1.default.createElement(material_1.Typography, { component: "div", variant: "h3", color: "primary", sx: { fontWeight: 600, textAlign: "center" } },
            "Paid Succesfully",
            " ")));
}
exports.default = CheckoutSuccess;
